import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';

export const StyledBrowseCategoriesWrapper = styled.div`
  margin-top: 1.6rem;
  margin-bottom: 0.6rem;
  min-height: 58.3rem;
  max-height: 58.3rem;
  height: 100%;
  overflow-y: scroll;
  padding-right: 0.5rem;
`;

export const StyledSearchIcon = styled(FontAwesomeIcon)<{ isDarkMode: boolean }>`
  && {
    color: ${({ theme, isDarkMode }) => (isDarkMode ? theme.colors.grey[400] : theme.colors.grey[700])};
  }
`;
